import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  PdsBox,
  PdsMantineText,
  PdsMantineButton,
  PdsDashboard1Icon,
  PdsDocument1Icon,
  PdsLoginIcon,
  PdsSearchIcon,
  PdsNetworkIcon,
} from '@podium-design-system/react-components';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to log out?')) {
      logout();
    }
  };

  return (
    <header className="header">
      <PdsBox direction="row" alignItems="center" gap="md">
        <img src="/sportradar-logo.png" alt="Sportradar" className="logo" />
        <PdsBox direction="row" alignItems="center" gap="sm">
          <PdsSearchIcon color="action" surface="on-dark" size="xl" />
          <PdsMantineText
            type="headline"
            surface="on-dark"
            fontWeight="strong"
            className="header-argus-wordmark"
          >
            Argus
          </PdsMantineText>
        </PdsBox>
        <PdsBox direction="row" alignItems="center" gap="xs" style={{ marginLeft: 16 }}>
          <PdsMantineButton
            component={Link}
            to="/"
            rank={isActive('/') ? 'fill' : 'ghost'}
            color="neutral"
            surface="on-dark"
            size="sm"
            leadingIcon={<PdsDashboard1Icon />}
          >
            Home
          </PdsMantineButton>
          <PdsMantineButton
            component={Link}
            to="/cases"
            rank={isActive('/cases') ? 'fill' : 'ghost'}
            color="neutral"
            surface="on-dark"
            size="sm"
            leadingIcon={<PdsDocument1Icon />}
          >
            Cases
          </PdsMantineButton>
          <PdsMantineButton
            component={Link}
            to="/api-limits"
            rank={isActive('/api-limits') ? 'fill' : 'ghost'}
            color="neutral"
            surface="on-dark"
            size="sm"
            leadingIcon={<PdsNetworkIcon />}
          >
            API Limits
          </PdsMantineButton>
        </PdsBox>
      </PdsBox>

      <PdsMantineButton
        rank="outline"
        color="neutral"
        surface="on-dark"
        size="sm"
        onClick={handleLogout}
        leadingIcon={<PdsLoginIcon />}
      >
        Logout
      </PdsMantineButton>
    </header>
  );
};

export default Header;
